var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColumns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297.5,
    height: 297.5,
    viewBox: "0 0 290 290",
    xmlns: "http://www.w3.org/23D3C3C/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "svg_30"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 10,
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    id: "svg_6",
    y2: 256.54216,
    x2: 128.01416,
    y1: 40.95785,
    x1: 128.01416,
    stroke: "#3D3C3C",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_28"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 15.5,
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    id: "svg_1",
    y2: 130.30566,
    x2: 22.4018,
    y1: 130.30566,
    x1: 107.73954,
    stroke: "#3D3C3C",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 15.5,
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    id: "svg_2",
    y2: 157.41664,
    x2: 29.446,
    y1: 157.41664,
    x1: 100.69534,
    stroke: "#3D3C3C",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_29"
  }, /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    id: "svg_9",
    y2: 111.87288,
    x2: 147.55492,
    y1: 111.87288,
    x1: 254.6805,
    strokeWidth: 10.5,
    stroke: "#3D3C3C",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 8,
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    id: "svg_10",
    y2: 128.31729,
    x2: 147.5982,
    y1: 128.31729,
    x1: 275.0982,
    stroke: "#3D3C3C",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_33"
  }, /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    id: "svg_31",
    y2: 58.9433,
    x2: 147.55492,
    y1: 58.9433,
    x1: 254.6805,
    strokeWidth: 10.5,
    stroke: "#3D3C3C",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 8,
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    id: "svg_32",
    y2: 75.38771,
    x2: 147.5982,
    y1: 75.38771,
    x1: 275.0982,
    stroke: "#3D3C3C",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_54"
  }, /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    id: "svg_52",
    y2: 168.77725,
    x2: 147.55492,
    y1: 168.77725,
    x1: 254.6805,
    strokeWidth: 10.5,
    stroke: "#3D3C3C",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 8,
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    id: "svg_53",
    y2: 185.22165,
    x2: 147.5982,
    y1: 185.22165,
    x1: 275.0982,
    stroke: "#3D3C3C",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_57"
  }, /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    id: "svg_55",
    y2: 222.11229,
    x2: 147.55492,
    y1: 222.11229,
    x1: 254.6805,
    strokeWidth: 10.5,
    stroke: "#3D3C3C",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 8,
    strokeLinecap: "undefined",
    strokeLinejoin: "undefined",
    id: "svg_56",
    y2: 238.5567,
    x2: 147.5982,
    y1: 238.5567,
    x1: 275.0982,
    stroke: "#3D3C3C",
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumns);
export default __webpack_public_path__ + "static/media/columns.5b791f8267a858489b24bf0af8495132.svg";
export { ForwardRef as ReactComponent };